@import "@/ui/variables.css";

.tooltip {
  background: oklch(from var(--gray) l c h/0.8);
  border: none;
  color: var(--white);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius);

  transition: opacity 300ms;
  z-index: 99;
}
